// extracted by mini-css-extract-plugin
module.exports = {"copyable-link":"copyable-link__copyable-link___h9_VG","copyable-link--white":"copyable-link__copyable-link--white___2IG1s copyable-link__copyable-link___h9_VG"};